/* eslint no-undef: 0 */
/* eslint arrow-parens: 0 */
import React, {useEffect} from 'react';
import { Steps, Button, message, Statistic } from 'antd';

import Package from './Package';
import Period from './Period';
import Payment from './Payment';
import Option from './Option';

import './less/antMotionStyle.less';

const { Step } = Steps;

const steps = [
  {
    title: 'طرح',
  },
  {
    title: 'دوره',
  },
  {
    title: 'بسته',
  },
  {
    title: 'تایید و پرداخت',
  },
];

const OnlineClass = (props) => {

  useEffect(() => {
    window.scrollTo(0, 0)
  });

  const [current, setCurrent] = React.useState(0);

  const [bascket, setBascket] = React.useState(null);

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const callbackFunction = (childData) => {
    setBascket(childData);
    next();
  };

  return (

    <div className="main">
      <div className="container">
        <div className="page-title">
          <h1>سفارش سرویس</h1>
        </div>
        <h5 className="page-subtitle">
        </h5>
        <Steps current={current}>
          {steps.map(item => (
            <Step key={item.title} title={item.title} />
          ))}
        </Steps>
        <div className="steps-content">
          {current === 0 && (
            <Package
              parentCallback={callbackFunction}
            />
          )
          }

          {current === 1 && (
            <Period
              parentCallback={callbackFunction}
            />
          )
          }

          {current === 2 && (
            <Option
              parentCallback={callbackFunction}
            />
          )
          }

          {current === 3 && (
            <Payment
              parentCallback={callbackFunction}
            />
          )
          }

        </div>


        <div className="steps-action">
          <div className="price">
            {current > 0 && current < 3 && (
              <Statistic title="مبلغ قابل پرداخت: " value={112893} suffix=" تومان " />
            )}
          </div>
          <div className="btn-group">
            {current > 0 && current < 3 && (
              <Button type="primary" onClick={() => next()}>
                ادامه فرایند خرید
              </Button>
            )}
            {current === 3 && (
              <Button type="primary" onClick={() => message.success('Processing complete!')}>
                پرداخت
              </Button>
            )}
            {current > 0 && (
              <Button style={{ margin: '0 8px' }} onClick={() => prev()}>
                بازگشت
              </Button>
            )}
          </div>

        </div>
      </div>
    </div>

  );
};
export default OnlineClass;